import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import "./Login.css";
import { config } from "../../config";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const resetToken =
    new URLSearchParams(location.search).get("resetToken") ||
    new URLSearchParams(location.search).get("token");
  const isResetPage =
    location.pathname === "/reset-password" || Boolean(resetToken);
  const passwordsMatch =
    confirmPassword.length > 0 && newPassword === confirmPassword;
  const passwordsMismatch =
    confirmPassword.length > 0 && newPassword !== confirmPassword;
  const onChange = (event) => {
    setUserData({ ...userData, [event.target.name]: event.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const isEmailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email);
      const bodyData = {
        password: userData.password,
      };

      // Automatically detect and set the correct key
      if (isEmailFormat) {
        bodyData.email = userData.email;
      } else {
        bodyData.username = userData.email;
      }

      const response = await fetch(`${config.backEndBaseUrl}admin/signin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      const json = await response.json();

      if (json.status) {
        localStorage.setItem("adminToken", json.token);
        localStorage.setItem("adminUserId", json.userId);
        localStorage.setItem("adminRole", json.role);
        if (json.role === "sub-admin") {
          localStorage.setItem("adminCity", json.city);
        }
        // return
        toast.success(json.message, {
          position: "top-right",
        });

        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      } else {
        // console.log("Login failed:", json.message);
        toast.error(json.message || "Wrong Email or Password", {
          position: "top-right",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Internal server error", {
        position: "top-right",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config.backEndBaseUrl}admin/forget-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: userData.email.trim() }),
        },
      );
      const json = await response.json();
      if (response.ok) {
        toast.success(
          json.status || "Password reset email sent. Check your inbox.",
        );
        setIsResetMode(false);
      } else {
        toast.error(
          json.error || json.message || "We could not send a reset email.",
        );
      }
    } catch (err) {
      toast.error("Unable to connect. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    if (!resetToken) return toast.error("This reset link is invalid.");
    if (newPassword.length < 8)
      return toast.error("Password must be at least 8 characters.");
    if (newPassword !== confirmPassword)
      return toast.error("Passwords do not match.");
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config.backEndBaseUrl}admin/reset-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: resetToken, password: newPassword }),
        },
      );
      const json = await response.json();
      if (!response.ok || !json.status)
        throw new Error(json.message || "Unable to reset password.");
      toast.success(json.message);
      setTimeout(() => navigate("/login"), 1200);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="login-main">
        <section className="login-auth-panel">
          <div className="login-right-container">
            <div className="login-center">
              <div className="login-product">
                <img
                  src={`${config.frontEndBaseUrl}adminAssets/images/payLogo.jpg`}
                  alt="Click4Driver"
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                  }}
                />
                <span>Click4Driver</span>
              </div>
              <h2>
                {isResetPage
                  ? "Choose a new password"
                  : isResetMode
                    ? "Reset password"
                    : "Sign in"}
              </h2>
              <p>
                {isResetPage
                  ? "Create a new password for your Click4Driver account."
                  : isResetMode
                    ? "Enter your admin email and we’ll send a secure reset link."
                    : "Enter your account details to access the admin panel."}
              </p>
              <form
                className="loginFrom"
                onSubmit={
                  isResetPage
                    ? handleNewPassword
                    : isResetMode
                      ? handlePasswordReset
                      : handleSubmit
                }
                autoComplete="off"
              >
                {!isResetPage && (
                  <>
                    <label className="login-field-label" htmlFor="login-email">
                      Email <b>*</b>
                    </label>
                    <input
                      id="login-email"
                      type="text"
                      placeholder="Enter your email"
                      required
                      name="email"
                      value={userData.email}
                      onChange={onChange}
                      className="loginInp"
                    />
                  </>
                )}
                {!isResetMode && !isResetPage && (
                  <div className="pass-input-div">
                    <label
                      className="login-field-label"
                      htmlFor="login-password"
                    >
                      Password <b>*</b>
                    </label>
                    <input
                      id="login-password"
                      className="loginInp"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      required
                      name="password"
                      value={userData.password}
                      onChange={onChange}
                    />
                    {showPassword ? (
                      <FaEyeSlash
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      />
                    ) : (
                      <FaEye
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      />
                    )}
                  </div>
                )}
                {isResetPage && (
                  <>
                    <label className="login-field-label" htmlFor="new-password">
                      New password <b>*</b>
                    </label>
                    <div className="reset-password-input">
                      <input
                        id="new-password"
                        className="loginInp"
                        type={showNewPassword ? "text" : "password"}
                        placeholder="At least 8 characters"
                        required
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        aria-label={
                          showNewPassword
                            ? "Hide new password"
                            : "Show new password"
                        }
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    <label
                      className="login-field-label"
                      htmlFor="confirm-password"
                    >
                      Confirm password <b>*</b>
                    </label>
                    <div className="reset-password-input">
                      <input
                        id="confirm-password"
                        className={`loginInp ${passwordsMismatch ? "password-mismatch" : passwordsMatch ? "password-match" : ""}`}
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Re-enter your password"
                        required
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <button
                        type="button"
                        aria-label={
                          showConfirmPassword
                            ? "Hide confirmation password"
                            : "Show confirmation password"
                        }
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    <small
                      className={`password-match-message ${passwordsMismatch ? "error" : passwordsMatch ? "success" : ""}`}
                      aria-live="polite"
                    >
                      {passwordsMismatch
                        ? "Passwords do not match."
                        : passwordsMatch
                          ? "Passwords match."
                          : "Re-enter your new password to confirm it."}
                    </small>
                  </>
                )}

                <div className="login-center-buttons">
                  <button type="submit" disabled={isLoading}>
                    {isLoading
                      ? "Please wait..."
                      : isResetPage
                        ? "Update password"
                        : isResetMode
                          ? "Send reset link"
                          : "Log in"}
                  </button>
                </div>
              </form>
              {!isResetPage && (
                <button
                  className="login-link"
                  type="button"
                  onClick={() => setIsResetMode(!isResetMode)}
                >
                  {isResetMode ? (
                    <>
                      <FaArrowLeft /> Back to sign in
                    </>
                  ) : (
                    "Forgot password?"
                  )}
                </button>
              )}
            </div>
          </div>
        </section>
        <section className="login-brand-panel" aria-hidden="true">
          <div className="login-brand-bg"></div>
          <div className="login-brand-grid"></div>
          <div className="login-brand-content">
            <img
              src={`${config.frontEndBaseUrl}adminAssets/images/payLogo.jpg`}
              alt="Click4Driver"
              onError={(event) => {
                event.currentTarget.style.display = "none";
              }}
            />
            <h1>
              Click<span>4</span>Driver
            </h1>

            <p>
              Smarter rides. <strong>Seamless control.</strong>
            </p>
          </div>
          {/* <div className="login-brand-orb"></div> */}
        </section>
      </div>
    </>
  );
};

export default Login;
